import { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false,
};

/** The brand mark: two concentric arches — a doorway. */
export function Doorway({ strokeWidth = 1.6, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      aria-hidden
      focusable="false"
      {...props}
    >
      <path d="M4.5 28.5V14a11.5 11.5 0 0 1 23 0v14.5" />
      <path d="M11.5 28.5V14.5a4.5 4.5 0 0 1 9 0v14" />
    </svg>
  );
}

export function Shield(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 21s7-3.2 7-9V5.9L12 3 5 5.9V12c0 5.8 7 9 7 9Z" />
      <path d="m9 11.8 2.1 2.2L15 10" />
    </svg>
  );
}

export function Quill(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M4 20s1.5-6.5 6.5-11S20 3 20 3s0 6-3 10.5S8.5 19 6 19" />
      <path d="M4 20c2.5 0 5-1 7-2.5" />
      <path d="M11 12.5h4" />
    </svg>
  );
}

export function Vault(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <rect x="3" y="4.5" width="18" height="15" rx="2" />
      <circle cx="11" cy="12" r="3.3" />
      <path d="M11 8.7v-1M11 16.3v1M14.3 12h1M6.7 12h1" />
      <path d="M18 8.5v7" />
    </svg>
  );
}

export function Handshake(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <path d="M2.5 12.5 6 9l3.5 3.5 2.5-2.5 2.5 2.5L18 9l3.5 3.5" />
      <path d="M6 9V7.5a1.5 1.5 0 0 1 1.5-1.5h9A1.5 1.5 0 0 1 18 7.5V9" />
      <path d="m12 10-2.8 2.8a1.7 1.7 0 0 0 0 2.4l2 2a1.7 1.7 0 0 0 2.4 0L17 16" />
    </svg>
  );
}

export function People(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="9" cy="8.5" r="3.2" />
      <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
      <path d="M16.2 5.7a3.2 3.2 0 0 1 0 5.7" />
      <path d="M17.5 14.9a5.5 5.5 0 0 1 3 5.1" />
    </svg>
  );
}

export function Clock(props: IconProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </svg>
  );
}

export function Check(props: IconProps) {
  return (
    <svg {...base} strokeWidth={1.8} {...props}>
      <path d="m4.5 12.5 4.5 4.5L19.5 6.5" />
    </svg>
  );
}

export function Arrow(props: IconProps) {
  return (
    <svg {...base} width={18} height={18} strokeWidth={1.6} {...props}>
      <path d="M4.5 12h14" />
      <path d="m13 6.5 5.5 5.5-5.5 5.5" />
    </svg>
  );
}

export function Plus(props: IconProps) {
  return (
    <svg {...base} strokeWidth={1.6} {...props}>
      <path d="M12 5.5v13M5.5 12h13" />
    </svg>
  );
}

export const pillarIcons = {
  shield: Shield,
  quill: Quill,
  vault: Vault,
  handshake: Handshake,
  people: People,
  clock: Clock,
} as const;
